export const GET_WIDGETS_BY_PAGE_ID = 'GET_WIDGETS_BY_PAGE_ID'
export const GET_WIDGETS_BY_PAGE_ID_SUCCESS = 'GET_WIDGETS_BY_PAGE_ID_SUCCESS'
export const CREATE_WIDGET = 'CREATE_WIDGET'
export const DUPLICATE_WIDGET_TO_ANOTHER_PAGE = 'DUPLICATE_WIDGET_TO_ANOTHER_PAGE'